export const nextSlugQuery = (slug: string) =>
  `*[meta.slug.current in ["${slug}"]]`;

export const nextIdQuery = (id: string) => `*[_id == "${id}"]`;

export const nextArchivePageQuery = (type: string) => `*[_type in ["${type}"]]`;

/**
 * used for archive pages to filter out the published versions if there is a draft
 * @param allArticles
 * @returns boolean
 */
export const filterRepeatedArticles = (
  allArticles: {
    _id: string;
  }[],
) => {
  const allIds = allArticles.map((page) => page._id);

  return allArticles.filter((page) => {
    if (allIds.includes("drafts." + page._id)) {
      return false;
    }
    return true;
  });
};

export const filterAllSiteUrlPages = (pages: { page: { _id: string } }[]) => {
  const validPages = pages.filter(({ page }) => page?._id);
  const allIds = validPages.map(({ page }) => page._id);

  return validPages.filter(({ page }) => {
    if (allIds.includes("drafts." + page._id)) {
      return false;
    }
    return true;
  });
};
